<script>
import {defineComponent} from 'vue';
import {goodsDetail} from "../api/api";
// import ImageCarousel from './components/ImageCarousel.vue';

export default defineComponent({
  name: "productDetail",
  data() {
    return {
      id: '',
      dataObj: {},
      imageArr: [],
      type: null,
      currentImageIndex: 0,
      imagesToShow: 5, // 每次展示的图片数量
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    console.log(this.id, '打印id');
    this.GoodsDetail();
  },
  // components: {
  //     ImageCarousel,
  //   },
  methods: {
    GoodsDetail() {
      goodsDetail({
        id: this.id
      }).then(res => {
        this.dataObj = res.data.data.info;
        this.imageArr = this.dataObj.images.split("|");
      });
    },
    prevImages() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex -= this.imagesToShow;
      }
    },
    nextImages() {
      if (this.currentImageIndex + this.imagesToShow < this.imageArr.length) {
        this.currentImageIndex += this.imagesToShow;
      }
    },
    updateMainImage(index) {
		setTimeout(()=>{
			this.dataObj.image = this.imageArr[index];
		},100)
      
    }
  }
});
</script>

<template>
  <div>
    <section id="about-us" class="padding-large no-padding-top">
      <div class="container">
        <div class="row d-flex flex-wrap align-items-center justify-content-between">
          <div class="col-md-6">
            <div class="image-holder mb-4">
              <div>
                <!-- <div id="app">
                    <ImageCarousel />
                  </div> -->
                <el-image 
                  :preview-src-list="imageArr"
                  :src="dataObj.image" 
                  class="single-image img-fluid">
                </el-image>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
                  <button @click="prevImages" :disabled="currentImageIndex === 0">
                    &lt;
                  </button>
                  <div style="display: flex; flex-wrap: nowrap; overflow: hidden;  width: 80%;">
                    <div v-for="(item, index) in imageArr.slice(currentImageIndex, currentImageIndex + imagesToShow)" 
                      :key="index" 
                      style="width: 19%; display: flex; align-items: center; margin-left: 1.5%; justify-content: center; overflow: hidden; background-color: #f9f9fb; border: 1px solid lightgray; ">
                      <img :src="item" 
                        style="width: 85%; cursor: pointer;" 
                        @click="updateMainImage(currentImageIndex + index)" >
                    </div>
                  </div>
                  <button @click="nextImages" :disabled="currentImageIndex + imagesToShow >= imageArr.length">
                    &gt;
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="detail ps-5">
              <div class="display-header">
                <p class="pb-3">LOT {{dataObj.describe}}</p>
                <h2>{{dataObj.title}}</h2>
                <h3 >成交价：{{dataObj.price}} RMB</h3>
                <div style="margin-top: 40px">
				
                  <p class="pb-3">拍卖时间：{{dataObj.pai_time}}</p>
                  <p class="pb-3">项目负责：{{dataObj.paitime.admin}}</p>
                  <p class="pb-3">拍卖地点: {{dataObj.address}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="about-us" class="padding-large no-padding-top">
      <div class="container">
        <div class="row d-flex flex-wrap align-items-center justify-content-between">
          <div class="col-md-12">
            <div class="detail ps-5">
              <div class="display-header">
                <p class="pb-3">拍品描述</p>
                <p class="pb-3">
					{{dataObj.detail}}
                <!-- <img style="width: 100%" :src="item" v-for="(item,index) in imageArr" :key="index"> -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.single-image {
  cursor: pointer;
}

button {
  border: none;
  background: transparent;
  font-size: 24px;
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
  color: grey;
}
.changeBig :hover{
	scale: (1.5);
}
</style>



// WEBPACK FOOTER //
// src/view/productDetail.vue